import { ActionContext, ActionTree, GetterTree, Module, MutationTree } from 'vuex';
import { useToast } from 'vue-toastification';
import { RootState } from '..';
import { Law } from './law.model';
import lawService from './law.service';

// namespace
export const LAW_STORE_NAMESPACE = 'lawStore';

// state
interface LawState {
  laws: Law[];
  status: 'init' | 'idle' | 'loading' | 'failed';
}

const initialState: LawState = {
  laws: [],
  status: 'init'
};

// mutation
const mutationConstant = {
  FETCH: 'fetch',
  PENDING: 'pending',
  FULFILLED: 'fulfilled',
  REJECTED: 'rejected'
};

const mutation: MutationTree<LawState> = {
  [mutationConstant.FETCH]: (state: LawState, laws: Law[]) => {
    state.laws = laws;
  },
  [mutationConstant.PENDING]: (state: LawState) => {
    state.status = 'loading';
  },
  [mutationConstant.FULFILLED]: (state: LawState) => {
    state.status = 'idle';
  },
  [mutationConstant.REJECTED]: (state: LawState) => {
    state.status = 'failed';
  },
};

// action
const toast = useToast();
const actionConstant = {
  FETCH: 'fetch',
};

const action: ActionTree<LawState, RootState> = {
  [actionConstant.FETCH](context: ActionContext<LawState, RootState>) {
    return new Promise<void>((resolve, reject) => {
      context.commit(mutationConstant.PENDING);
      lawService.Fetch()
        .then((response) => {
          context.commit(mutationConstant.FETCH, response.data);
          context.commit(mutationConstant.FULFILLED);
          resolve();
        })
        .catch(() => {
          context.commit(mutationConstant.REJECTED);
          toast.error('ไม่สามารถเรียกข้อมูลได้');
          reject();
        });
    });
  },
};

// getter
const getterConstant = {
  ALL: 'all',
  BY_ID: 'byId',
  STATUS: 'status'
};

const getter: GetterTree<LawState, RootState> = {
  [getterConstant.ALL]: (state: LawState) => state.laws,
  [getterConstant.BY_ID]: (state: LawState) => (id: number) => state.laws.find(m => m.id === id),
  [getterConstant.STATUS]: (state: LawState) => state.status,
};

// module
const module: Module<LawState, RootState> = {
  namespaced: true,
  state: initialState,
  mutations: mutation,
  actions: action,
  getters: getter
};

// export
export const LawGetter = {
  ALL: `${LAW_STORE_NAMESPACE}/${getterConstant.ALL}`,
  BY_ID: `${LAW_STORE_NAMESPACE}/${getterConstant.BY_ID}`,
  STATUS: `${LAW_STORE_NAMESPACE}/${getterConstant.STATUS}`
};

export const LawAction = {
  FETCH: `${LAW_STORE_NAMESPACE}/${actionConstant.FETCH}`,
};

export default module;
